// /* eslint-disable */
import loadGoogleMapsApi from "load-google-maps-api";
import scrollTo from "../util/ScrollTo";
import includes from "../util/includes";
import getSearchParameters from "../util/getSearchParameters";

export default {
    init() {
        // JavaScript to be fired on the home page
        let mapElement = document.querySelector("#service-map");
        let filter = getSearchParameters("filter");

        if (mapElement) {
            Map.loadGoogleMapsApi({})
                .then(function (googleMaps) {
                    let mapObject = Map.createMap(googleMaps, mapElement);
                    let serviceFinder = new ServiceFinder(googleMaps, mapObject, mapElement);

                    new Questionnaire(serviceFinder);
                    new FilterMarkers(serviceFinder, filter);
                    new MapActions(serviceFinder);
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};


class MapActions {
    constructor(serviceFinder) {
        this.serviceFinder = serviceFinder;
        this.addEvents();
    }

    addEvents() {
        let _this = this;
        $(".service-form").submit(function (e) {
            e.preventDefault();
            const postcode = $('#service-form__postcode', this).val();

            if (postcode) {
                _this.queryLatLng(postcode);
            } else {
                _this.serviceFinder.centreOnBounds()
            }
        });
    }

    queryLatLng(postcode) {
        var ajax = $.ajax({
            context: this,
                method: 'get',
                data: {
                    'postcode': postcode,
            },
            dataType: 'json',
            url: '/wp-json/bsh_api/v1/location',
        });

        ajax.done((data) => {
            if (data.status === 200) {
                this.serviceFinder.setPosition(data.response.latlng, 12);
            } else {
                alert('Sorry this postcode could not be found');
            }
        })
    }
    }

    class FilterMarkers {
        constructor(serviceFinder, filter) {
            this.serviceFinder = serviceFinder;
            this.addClickEvents();

            if (filter) {
                this.initFilter(filter);
            }
        }

        initFilter(filter) {
            let filterName = '';

            switch (filter) {
                case 'emergency-contraception':
                    filterName = 'ehc';
                    break;
                case 'PEP':
                    filterName = 'bshaw';
                    break;
                case 'sexual-assault':
                    filterName = 'sarc';
                    break;
                case 'free-condoms':
                    filterName = 'condomScheme';
                    break;
            }

            var filterElement = $(".service-filter-list__option[data-filter-type=" + filterName + "]");

            $("#map-filtered-text")
                .text($(filterElement).data('filter-title'))
                .removeClass('d-none');

            $(".service-content[data-service-type=" + filterName + "]").show();
            scrollTo($(".service-content[data-service-type=" + filterName + "]"));

            this.serviceFinder.hideAll();
            this.serviceFinder.showCategory(filterName);
        }

        addClickEvents() {
            var _this = this;

            $(".service-filter-list__option").click(function () {
                const display = $(this).data('filter-type');
                const title = $(this).data('filter-title');

                $("#map-filtered-text")
                .text(title)
                .removeClass('d-none');

                $(".service-content").hide();
                $(".service-content[data-service-type=" + display + "]").show();
                scrollTo($(".service-content[data-service-type=" + display + "]"));

                _this.serviceFinder.hideAll();
                _this.serviceFinder.showCategory(display);
            });

            $(".service-filter-list__option button").keyup(function (event) {
                if (event.keyCode == '13') {
                    const display = $(this).data('filter-type');
                    const title = $(this).data('filter-title');

                    $("#map-filtered-text")
                    .text(title)
                    .removeClass('d-none');

                    $(".service-content").hide();
                    $(".service-content[data-service-type=" + display + "]").show();
                    scrollTo($(".service-content[data-service-type=" + display + "]"));

                    _this.serviceFinder.hideAll();
                    _this.serviceFinder.showCategory(display);
                }
            });

            $(".map-marker__list-item").click(function () {
                const display = $(this).data('toggle-items');
                $("#map-filtered-text").addClass('d-none');
                _this.serviceFinder.hideAll();
                _this.serviceFinder.showCategory(display);
            });
        }
    }


    class Questionnaire {
        constructor(serviceFinder) {
            this.serviceFinder = serviceFinder;
            this.resetForm();
            this.addEventListeners();
        }

        resetForm() {
            $(".question__select").val($(".question__select option:first").val());
        }

        addEventListeners() {
            $(".question__select").on("change", () => {
                this.updateVisible();
            })
        }

        getAnswer(questionNumber) {
            return $("#question" + questionNumber).val();
        }

        displayMarkers(markers) {
            this.serviceFinder.hideAll();
            this.serviceFinder.showCategories(markers);
        }

        updateVisible() {
            var answer1 = this.getAnswer(1);

            // plot markers
            // for other / hide
            // proceding inputs
            if (answer1 === "other") {
                this.displayMarkers(["bshaw"]);
            } else {
                $(".question__row:not(.question__row--1)").addClass('d-none');
            }

            // display section level
            // on answers bsaed on 1
            if (answer1 === "male") {
                // update visibility
                // of proceding questions
                $(".question__row--2").removeClass("d-none");
                $(".question__row--3").addClass("d-none");
                $(".question__row--4").addClass("d-none");

                // who do you have
                // sex with?
                var answer2 = this.getAnswer(2);

                if (answer2 === "men" || answer2 === "men_women") {
                    this.displayMarkers(["bshaw"]);
                } else if (answer2 === "women") {
                    $(".question__row--3").removeClass("d-none");
                }

                // do you have symptoms?
                var answer3 = this.getAnswer(3);
                if (answer3 == 1) {
                    this.displayMarkers(["bshaw"]);
                } else if (answer3 == 0) {
                    this.displayMarkers(["bshaw", "gp", "outreach"]);
                }
            }

            if (answer1 === "female") {
                // update visibility of
                // proceding questions
                $(".question__row--2").addClass("d-none");
                $(".question__row--3").removeClass("d-none");


                if (this.getAnswer(3) == 1) {
                    this.displayMarkers(["bshaw"]);
                    $(".question__row--4").addClass("d-none");
                } else if (this.getAnswer(3) == 0) {
                    $(".question__row--4").removeClass("d-none")
                } else {
                    $(".question__row--4").addClass("d-none");
                }

                // discuss
                // contraceptive choices
                var answer4 = this.getAnswer(4);

                if (answer4 == 1 || answer4 == 0) {
                    this.displayMarkers(['bshaw', 'gp', 'outreach'])
                }
            }
        }
    }


    class Map {
        static loadGoogleMapsApi() {
            let options = {};

            if (window.hasOwnProperty('dv_googlemap_key')) {
                options.key = window.dv_googlemap_key;
            }

            return loadGoogleMapsApi(options);
        }
        static createMap(googleMaps, mapElement) {
            return new googleMaps.Map(mapElement, {
                center: {
                    lat: 51.775955,
                    lng: -0.774273,
                },
                zoom: 14,
            });
        }
    }

    class MapModal {
        constructor(googleMap) {
            this.googleMap = googleMap;
            this.infoWindow = new googleMap.InfoWindow({});
        }
        open(marker, map, centre) {
            let content = this.getContent(centre);
            this.infoWindow.open(map, marker);
            this.infoWindow.setContent(content);
        }
        getContent(centre) {
            let ages = centre.Ages.map((age) => {
                return age.name;
            });

        let header = '<div class="gmap-popup">' +
            '<div class="gmap-popup__title">' + centre.title + '</div>';

        if (centre.hasOwnProperty('featuredImage')) {
            header += '<div class="gmap-popup__thumbnail"><img src="' + centre.featuredImage.url + '" alt="' + centre.featuredImage.alt + '">';
        }

        let body = '<ul class="gmap-popup__list"><li class="gmap-popup__list-item gmap-popup__list-item--address">' + centre.address.address + '</li>';

        if (centre.phone.length > 0) {
            body += '<li class="gmap-popup__list-item gmap-popup__list-item--phone">' + centre.phone + '</li>';
        }

        if (ages.length > 0) {
            body += '<li class="gmap-popup__list-item gmap-popup__list-item--ages">' + ages.join(', ') + '</li>';
        }
        body += "</ul>";

        let footer = '<a href="' + centre.permalink + '" class="gmap-popup__cta rounded-button rounded-button--purple">Service Details</a></div>';

        return (header + body + footer);
        }
    }

    class MarkerIcons {
        constructor() {
            this.icons = {};
            this.setIcons();
        }
        setIcons() {
            const icons = document.querySelectorAll(".map-marker__list-item[data-icon]");

            if (icons) {
                icons.forEach(element => {
                    if (element.dataset.icon && element.dataset.toggleItems) {
                        console.log(element.dataset);
                        this.icons[element.dataset.iconName] = element.dataset.icon;
                    }
                });
            }
        }
        getIcon(iconType) {
            if (this.icons.hasOwnProperty(iconType)) {
                return this.icons[iconType]
            }

            return false;
        }
    }

    class ServiceFinder {

        constructor(googleMap, mapObject, element) {
            this.icons = new MarkerIcons();
            this.modal = new MapModal(googleMap);
            this.allMarkers = [];
            this.googleMap = googleMap;
            this.mapObject = mapObject;
            this.element = element;

            this.categories = {
                condomScheme: [],
                ehc: [],
                sarc: [],
                bshaw: [],
                outreach: [],
                pharmacy: [],
                gp: [],
            };

            this.parseMapData();
            this.plotMapMarkers();
        }

        setPosition(data, zoom = false) {
            this.mapObject.setCenter(new this.googleMap.LatLng(data.lat, data.lng));

            if (zoom) {
                this.mapObject.setZoom(zoom);
            }
        }

        /**
     * Setup map data from
     * element containing JSON dump
     */
        parseMapData() {
            let mapDataElement = document.querySelector("#google-map");

            if (mapDataElement != false) {
                this.mapData = JSON.parse(mapDataElement.innerHTML);
            }
        }


        setBounds(position) {
            if (this.bounds === undefined) {
                this.bounds = new this.googleMap.LatLngBounds();
            }

            this.bounds.extend(position);
        }

        resetBounds() {
            this.bounds = new this.googleMap.LatLngBounds();
        }

        getCategory(centre) {
            return centre.categories;
        }

        getIcon(type) {
            return this.icons.getIcon(type);
        }

        // categorises each centre
        // by required filter types
        addToFilterCategories(groups, marker) {
            if (includes(groups, 'gp')) {
                this.categories.gp.push(marker);
            }

            if (includes(groups, 'pharmacy')) {
                this.categories.pharmacy.push(marker);
            }

            if (includes(groups, 'bshaw')) {
                this.categories.bshaw.push(marker);
            }

            if (includes(groups, 'sarc')) {
                this.categories.sarc.push(marker);
            }

            if (includes(groups, 'condom-scheme')) {
                this.categories.condomScheme.push(marker);
            }

            if (includes(groups, 'ehc')) {
                this.categories.ehc.push(marker);
            }

            if (includes(groups, 'outreach')) {
                this.categories.outreach.push(marker);
            }

            this.allMarkers.push(marker);
        }

        showCategories(categories) {
            if (Array.isArray(categories)) {
                categories.forEach((category) => {
                    this.showCategory(category);
                })
            } else {
                this.showCategory(categories);
            }
        }

        showCategory(category) {
            if (this.categories.hasOwnProperty(category)) {
                this.categories[category].forEach((marker) => {
                    marker.setVisible(true);
                });
            }

            this.resetBounds();

            this.allMarkers.forEach((marker) => {
                if (marker.visible) {
                    this.setBounds(marker.position);
                }
                this.mapObject.fitBounds(this.bounds);
            })
        }

        hideCategory(category) {
            if (this.categories.hasOwnProperty(category)) {
                this.categories[category].forEach((marker) => {
                    marker.setVisible(false);
                })
            }
        }

        hideAll() {
            this.allMarkers.forEach((marker) => {
                marker.setVisible(false);
            })
        }

        showAll() {
            this.allMarkers.forEach((marker) => {
                marker.setVisible(true);
            })
        }

        centreOnBounds() {
            this.mapObject.fitBounds(this.bounds);
        }

        /**
     * Plots markers on map
     */
        plotMapMarkers() {
            this.mapData.forEach((centre) => {
                if (!centre.address.lat || !centre.address.lng) {
                    console.warn('centre address invalid', centre);
                    return;
                }

                const categories = this.getCategory(centre);

                const position = {
                    lat: parseFloat(centre.address.lat),
                    lng: parseFloat(centre.address.lng),
                };

                let marker = new this.googleMap.Marker({
                    position: position,
                    map: this.mapObject,
                    animation: this.googleMap.Animation.DROP,
                    icon: {
                        scaledSize: new this.googleMap.Size(24, 34),
                        url: this.getIcon(centre.markerType),
                        anchor: new this.googleMap.Point(12, 0),
                    },
                });

            marker.addListener('click', () => {
                this.modal.open(marker, this.mapObject, centre);
                });

            this.addToFilterCategories(categories, marker);
            this.setBounds(marker.position);
            });

        this.centreOnBounds();
        }
    }



// WEBPACK FOOTER //
// ./scripts/routes/serviceFinder.js